/* ════════════════════════════════════════════════════════════════════════
   Room Watercolour Identity — Phase 1 presentation layer.
   One bespoke hand-painted artwork per room, locked to the ARA palette.
   Decorative only: rendered aria-hidden behind room headings.
   ════════════════════════════════════════════════════════════════════════ */

import artToday from "../assets/watercolour/today.webp";
import artFamily from "../assets/watercolour/family.webp";
import artMeals from "../assets/watercolour/meals.webp";
import artPantry from "../assets/watercolour/pantry.webp";
import artMoney from "../assets/watercolour/money.webp";
import artHealth from "../assets/watercolour/health.webp";
import artDocuments from "../assets/watercolour/documents.webp";
import artHome from "../assets/watercolour/home.webp";
import artCleaning from "../assets/watercolour/cleaning.webp";
import artGoals from "../assets/watercolour/goals.webp";

export const ROOM_IDENTITY = {
  today:     { name: "Today",     accent: "#1F1F1F", src: artToday,     opacity: 0.80, width: "min(50%, 440px)" },
  family:    { name: "Family",    accent: "#7A6E63", secondary: "#E8D1D1", src: artFamily, opacity: 0.85, width: "min(44%, 380px)" },
  meals:     { name: "Kitchen",   accent: "#7C8B6E", src: artMeals,     opacity: 0.85, width: "min(48%, 420px)" },
  pantry:    { name: "Pantry",    accent: "#6E6F55", src: artPantry,    opacity: 0.82, width: "min(42%, 360px)" },
  money:     { name: "Study",     accent: "#24382C", src: artMoney,     opacity: 0.70, width: "min(48%, 420px)" },
  health:    { name: "Wellness",  accent: "#4E6E5D", src: artHealth,    opacity: 0.80, width: "min(44%, 380px)" },
  documents: { name: "Library",   accent: "#4A4E55", src: artDocuments, opacity: 0.80, width: "min(42%, 360px)" },
  home:      { name: "Home",      accent: "#5C4033", secondary: "#C77068", src: artHome, opacity: 0.72, width: "min(46%, 400px)" },
  cleaning:  { name: "Cleaning",  accent: "#A89B7A", src: artCleaning,  opacity: 0.88, width: "min(46%, 400px)" },
  goals:     { name: "Goals",     accent: "#B59A6D", secondary: "#D6B165", src: artGoals, opacity: 0.82, width: "min(50%, 440px)" },
};
